import React from "react";
import styles from "./StatusCheck.module.css";

type Variant = "success" | "warning" | "error";

interface Props {
  variant: Variant;
}

export default function StatusCheck({ variant }: Props) {
  return (
    <div className={styles.container} aria-hidden>
      <div className={`${styles.ok} ${styles[variant]}`}>
        <svg className={styles.icon} viewBox="0 0 24 24">
          {variant === "success" && (
            <path d="M5 12.5l4 4L19 7.5" />
          )}

          {variant === "warning" && (
            <>
              <path d="M12 6v8" />
              <circle cx="12" cy="18" r="1.4" fill="white" />
            </>
          )}

          {variant === "error" && (
            <>
              <path d="M7 7l10 10" />
              <path d="M17 7L7 17" />
            </>
          )}
        </svg>
      </div>
    </div>
  );
}
